import { whenDefined } from '@vy/null';
import { isEmptyString } from '@vy/string';
import type { UsageReportV2ReportItem } from '@vy/types';
import { caseInsensitiveIncludes } from '@vy/utils';

export function applyUsageReportV2Search(
  reportItems: UsageReportV2ReportItem[],
  searchText: string | null | undefined,
): UsageReportV2ReportItem[] {
  const normalized = searchText?.trim();
  if (isEmptyString(normalized)) {
    return reportItems;
  }

  return reportItems.filter((item) => {
    const matchesCustomerName = caseInsensitiveIncludes(item.customer.name, normalized);
    const matchesContractName = caseInsensitiveIncludes(item.contract.name, normalized);
    const matchesProductName = caseInsensitiveIncludes(item.product.name, normalized);
    const matchesProductGroupName = whenDefined(
      item.product.productGroupName,
      (groupName) => caseInsensitiveIncludes(groupName, normalized),
      false,
    );

    return matchesCustomerName || matchesContractName || matchesProductName || matchesProductGroupName;
  });
}
